import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { EDIT } from "const"
import {
    hasAccess,
    hasProjectAccess,
    hasLifecycleAccess,
} from "client/utils"
import {
    PRM_LIFECYCLE,
    StoreType,
    IsOwnerLifecycle,
    addModal,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Textarea,
    UserIcon,
    Button,
    Delimiter,
} from "client/components"

const Form = () => {
    const lifecycle = useSelector((state: StoreType) => state.lifecycle.lifecycleView)
    const baseRoute = useSelector((state: StoreType) => state.lifecycle.baseRoute)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const accountList = useSelector((state: StoreType) => state.account.accountList)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editUrl = `${baseRoute}/${EDIT}/${lifecycle.id}`


    const editAccess = !project.id
        ? hasAccess(PRM_LIFECYCLE, EDIT)
        : hasProjectAccess(PRM_LIFECYCLE, EDIT)

    const lifecycleEditAccess = hasLifecycleAccess(PRM_LIFECYCLE, EDIT)

    const isOwner = IsOwnerLifecycle(project.id, lifecycle, userData)
    const allowedToEdit = editAccess || isOwner || lifecycleEditAccess


    const creator = lifecycle.creator && userList[lifecycle.creator]
    const ownerAccount = lifecycle.ownerAccount && accountList[lifecycle.ownerAccount]
    const responsible = lifecycle.responsible && userList[lifecycle.responsible]

    return (
        <PageForm>
            <Row>
                <Col xs={12} md={9}>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.name}</Label>
                                <Input type="text" value={lifecycle.name} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.description}</Label>
                                <Textarea value={lifecycle.description} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.type}</Label>
                                <Input type="text" value={lang[lifecycle.type] || ""} readOnly />
                            </FormGroup>
                            {
                                !project.id && (
                                    <FormGroup>
                                        <Label>{lang.default}</Label>
                                        <Input type="text" value={lifecycle.default ? lang.yes : lang.no} readOnly />
                                    </FormGroup>
                                )
                            }
                        </Col>
                        {
                            allowedToEdit && (
                                <Col xs={12}>
                                    <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                        {lang.edit}
                                    </Button>
                                </Col>
                            )
                        }
                    </Row>
                </Col>

                <Col xs={12} md={3}>
                    <FormGroup>
                        <Label>{lang.createdBy}</Label>
                        {
                            !project.id && lifecycle.ownerAccount === userData.accountId
                            && <UserIcon user={creator} size="sm" />
                        }
                        {
                            !project.id && lifecycle.ownerAccount !== userData.accountId
                            && ownerAccount ? ownerAccount.name : ""
                        }
                        {
                            project.id
                            && ownerAccount ? ownerAccount.name : ""
                        }
                    </FormGroup>
                    {
                        userData.accountId !== 1 && ([
                            <Delimiter key="delimeter" size="sm" />,
                            <FormGroup key="responsible">
                                <Label>{lang.responsible}</Label>
                                <UserIcon user={responsible} size="sm" />
                            </FormGroup>,
                        ])
                    }
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
